<template>
    <div class="newshuo">
        <topMenu :linkList="linkList"></topMenu>
        <section class="section" id="section1">

            <img class="pc-img" src="../assets/image/newshuo/section1.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section1_m.jpg" alt="">
            <a href="https://forms.office.com/pages/responsepage.aspx?id=DjVMKhf5A0CxTnZDwyGIvQmkotM8Ij1Mrrox4Bh6eNZUNEJJVFRIUDlTV1dTTTlLWTY5UUZJWDhFNC4u&route=shorturl"
                target="_blank" class="link-a ebc-btn-large">
                立即领取
            </a>
        </section>
        <div class="aff-section7">
            <div class="section7SwiperList">
                <div class="shadow leftShadow"></div>
                <div class="shadow rightShadow"></div>
                <div class="marquee section7Swiper1">
                    <div class="marquee__track flex items-center">
                        <div class="swiper-slide">
                            <div class="swiperWordTag">搭建交易系统</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon1.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">理解庄家行为</div>
                        </div>

                        <div class="swiper-slide">
                            <div class="swiperWordTag">高效盈亏管理</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon2.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">价格行为分析</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">透视波动真相</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon3.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">交易员实战分享</div>
                        </div>

                    </div>
                </div>
                <div class="marquee section7Swiper2">
                    <div class="marquee__track flex items-center marquee--reverse">
                        <div class="swiper-slide">
                            <div class="swiperWordTag">实战进阶落地</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon5.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">洞悉市场本质</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon6.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">全球宏观视野</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">重塑交易心理</div>
                        </div>
                        <div class="swiper-slide">
                            <img src="../assets/image/newshuo/icon7.svg" alt="" class="swiperLogoTag" />
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">多层级风险控制</div>
                        </div>
                        <div class="swiper-slide">
                            <div class="swiperWordTag">资金和仓位管理</div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <section class="section" id="section2">
            <img class="pc-img" src="../assets/image/newshuo/section2.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section2_m.jpg" alt="">
        </section>
        <section class="section" id="section3">
            <img class="pc-img" src="../assets/image/newshuo/section3.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section3_m.jpg" alt="">
        </section>
        <section class="section" id="section4">
            <img class="pc-img" src="../assets/image/newshuo/section4.jpg" alt="">
            <img class="mobile-img" src="../assets/image/newshuo/section4_m.jpg" alt="">
        </section>
    </div>
</template>

<script>
import topMenu from '../components/topMenu/topMenu.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        topMenu
    },
    data() {
        return {
            linkList: [
                { name: "交易领书", target: "section2" },
                { name: "领取步骤", target: "section3" },
                { name: "活动规则", target: "section4" },
            ]
        }
    },
    mounted() {
        this.initPage()
    },
    methods: {
        async initPage() {
            console.log("in")
            function initMarquee(track, index) {
                if (!track) return;
                const originalContent = track.innerHTML;
                track.style.animationPlayState = 'paused';
                console.log("in2")
                // 等浏览器渲染
                requestAnimationFrame(() => {
                    const originalWidth = track.scrollWidth;
                    track.innerHTML = originalContent + originalContent + originalContent + originalContent;
                    track.style.width = (originalWidth * 4) + 'px';
                    track.style.setProperty('--s7move-distance', `-${originalWidth * 2}px`);
                    track.style.animation = 'none';
                    requestAnimationFrame(() => {
                        console.log("in3")
                        track.style.animation = 'marquee 140s linear infinite';
                        index == 1 && (track.style.animationDirection = 'reverse')
                    });
                });
            }
            document.querySelectorAll('.marquee__track').forEach((track, index) => {
                initMarquee(track, index)
            });
        }
    },
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>

<style lang="scss">
html {
    scroll-behavior: smooth !important;
}

body {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    /* 自动匹配用户系统默认字体 */

}

.el-dropdown-menu a {
    color: #666;
}

.newshuo .pc-img {
    width: 100vw;
}

.newshuo .mobile-img {
    display: none;
}

.newshuo {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;


    /* 自动匹配用户系统默认字体 */
    .link-a {
        position: absolute;
        left: 356rem;
        top: 600rem;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 48rem;
        min-width: 220rem;
        gap: 8rem;
        border-radius: 24rem;
        background: var(--Brand-Secondary-Red, #a52933);
        color: #fff;
        text-align: center;
        font-size: 16rem;
        font-style: normal;
        line-height: 28rem;
        cursor: pointer;
        font-weight: 500;
    }

    .link-a:hover {
        background: var(--Text-Primary_White, #fff);
        color: var(--Brand-Secondary-Red, #a52933);
    }

    .aff-section7 .shadow {
        position: absolute;
        top: 0;
        height: 100%;
        width: 330rem;
        z-index: 2;
    }

    .aff-section7 .leftShadow {
        background: linear-gradient(270deg, rgba(245, 245, 245, 0) 0%, #f5f5f5 100%);
        left: 0;
    }

    .aff-section7 .rightShadow {
        background: linear-gradient(270deg, #f5f5f5 0%, rgba(245, 245, 245, 0) 100%);
        right: 0;
    }


    .aff-section7 .swiperWordTag {
        border-radius: var(--Corner-Radius-Full, 999px);
        background: #fff;
        backdrop-filter: blur(8px);
        padding: 12rem 28rem;
    }

    .aff-section7 .swiperLogoTag {
        width: 48rem;
        height: 48rem;
    }

    .aff-section7 .section7SwiperList {
        padding: 60rem 0 32rem;
        background: #F9F6F2;
        position: relative;
    }

    .aff-section7 .section7SwiperList .marquee:nth-child(-n + 4) {
        margin-bottom: 28rem;
    }

    .aff-section7 .swiper-slide {
        width: fit-content;

        color: #9F734C;
        text-align: center;
        font-size: 20rem;
        font-weight: 500;
        line-height: 1;
    }

    .marquee {
        overflow: hidden;
        width: 100%;
    }

    .marquee--reverse.marquee__track {
        animation-direction: reverse;
    }

    .marquee__track {
        display: inline-flex;
        /* align-items: center; */
        gap: 20px;
        /* 对应 spaceBetween */

        /* 强制硬件加速 */
        /* transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0); */
        /* will-change: transform; */
        /* backface-visibility: hidden; */
        /* -webkit-backface-visibility: hidden; */
        animation: marquee 140s linear infinite;
        /* 调整 30s 控制速度 */
    }


}


@media (max-width: 996px) {
    .newshuo .pc-img {
        width: 100vw;
        display: none;
    }

    .newshuo .mobile-img {
        display: block;
        width: 100vw;
    }

    .newshuo {



        .link-a {
            left: 150rem;
            top: 1170rem;
            display: inline-flex;
            font-size: 32rem;
            font-style: normal;
            font-weight: 500;
            line-height: 56rem;
            min-width: 450rem;
            padding: 0 30rem;
            height: 80rem;
            border-radius: 40rem;
        }

        margin-top: -88rem;

        .aff-section7 .section7SwiperList .marquee:nth-child(-n + 4) {
            margin-bottom: 45rem;
        }

        .aff-section7 .swiperWordTag {
            padding: 20rem 46rem;
        }

        .aff-section7 .swiper-slide {
            font-size: 33rem;
            transition: none;

        }

        .marquee__track {
            gap: 33rem;
            animation: marquee 140s linear infinite;
            /* 调整 30s 控制速度 */
        }

        .aff-section7 .shadow {
            width: 130rem;
        }

        .aff-section7 .swiperLogoTag {
            width: 80rem;
            height: 80rem;
        }
    }
}

@keyframes marquee {
    0% {
        transform: translate3d(0, 0, 0);
    }

    100% {
        transform: translate3d(var(--s7move-distance), 0, 0);
    }
}
</style>